import { useContext } from "react";
import { MissionCtx } from "../MissionCtx";

function useMission()
{
	return useContext(MissionCtx);
}

export default useMission;
